const DEFAULT_LANGUAGE = "en";
const BACK_OFFICE_PORTALS = new Set(["admin", "superadmin"]);

export const isBackOfficePath = (pathname = "") =>
  /^\/(admin|superadmin)(\/|$)/.test(String(pathname));

export const isTranslationExcludedPath = (pathname = "") =>
  isBackOfficePath(pathname) || /^\/e-learning(\/|$)/.test(String(pathname));

export const isBackOfficeNavigation = (pathname = "", navigationState = {}) =>
  isBackOfficePath(pathname) ||
  BACK_OFFICE_PORTALS.has(String(navigationState?.sourcePortal || ""));

const getCurrentNavigationState = () =>
  typeof window !== "undefined" ? window.history.state?.usr || {} : {};

export const normalizeRequestLanguage = (value) => {
  const normalized = String(value || "")
    .split(",")[0]
    .split(";")[0]
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];

  return normalized || DEFAULT_LANGUAGE;
};

export const getUrlLanguage = (
  search = typeof window !== "undefined" ? window.location.search : ""
) => {
  const params = new URLSearchParams(search);
  const language = params.get("lang") || params.get("locale");

  return language ? normalizeRequestLanguage(language) : null;
};

export const getRequestLanguage = (
  search = typeof window !== "undefined" ? window.location.search : ""
) =>
  getUrlLanguage(search) ||
  normalizeRequestLanguage(localStorage.getItem("userLanguage"));

export const getInterfaceLanguage = (
  pathname = typeof window !== "undefined" ? window.location.pathname : "",
  navigationState = getCurrentNavigationState(),
  search = typeof window !== "undefined" ? window.location.search : ""
) =>
  isBackOfficeNavigation(pathname, navigationState) ||
  isTranslationExcludedPath(pathname)
    ? DEFAULT_LANGUAGE
    : getRequestLanguage(search);

export const shouldSendRequestLanguage = (
  pathname = typeof window !== "undefined" ? window.location.pathname : "",
  navigationState = getCurrentNavigationState()
) =>
  !isBackOfficeNavigation(pathname, navigationState) &&
  !isTranslationExcludedPath(pathname);

export const appendRequestLanguage = (url) => {
  const separator = String(url).includes("?") ? "&" : "?";
  return `${url}${separator}locale=${encodeURIComponent(getRequestLanguage())}`;
};

/**
 * Append the current language to an in-app PAGE link (not an API call).
 *
 * Uses `lang` to match the URLs the backend builds for the mobile WebView
 * (tncWebUrl / privacyWebUrl), so a policy page carries the same signal however
 * it was reached. Without this, opening the accessibility statement from the
 * account screen or the login footer dropped the language entirely and the page
 * fell back to English.
 *
 * `appendRequestLanguage` above is the API-call equivalent and uses `locale`.
 */
export const appendPageLanguage = (url) => {
  const separator = String(url).includes("?") ? "&" : "?";
  return `${url}${separator}lang=${encodeURIComponent(getRequestLanguage())}`;
};
